"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var m=e=>({checkboxRoot:{position:"relative"},error:{bottom:e.spacing(-3),position:"absolute",right:0}});exports.default=m;
//# sourceMappingURL=styles.js.map
